import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  right: 35.4rem;
  margin-top: 70px;
  width: 100%;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;

  .position-information {
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;

    .avatar {
      width: 57px;
      height: 57px;
      border-radius: 50%;
    }
  }

  .name {
    font-family: Montserrat;
    font-weight: 500;
    font-size: 14px;
    line-height: 35px;
    color: #000000;
  }

  .description {
    font-family: Montserrat;
    font-style: italic;
    font-weight: 300;
    font-size: 14px;
    line-height: 10px;
    color: #000000;
  }

  .separator {
    width: 100%;
    height: 1px;
    background: #c4c4c4;
  }
  .social-media {
    display: flex;
    flex-direction: row;
    margin-top: 0.5rem;
    margin-right: 0.5rem;
    z-index: 10;
    a {
      margin-left: 0.5rem;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0 auto;
    margin-top: 8.25rem;

    .position-information {
      position: absolute;

      .social-media {
        display: flex;
        flex-direction: row;

        a {
          margin-left: 0.3rem;
        }
      }
    }
  }
`;
